<div class="aria-field" [class.aria-field--floating-label]="useFloatingLabel()">
  @if (label() && !useFloatingLabel()) {
    <label class="aria-field__label" [attr.for]="fieldId">
      {{ label() }}
      @if (required()) {
        <span class="aria-field__required" aria-hidden="true">*</span>
      }
    </label>
  }

  <div class="aria-field__control-row">
    @if (hasPrefix()) {
      <div class="aria-field__prefix">
        <ng-content select="[ariaFieldPrefix]" />
      </div>
    }

    <div class="aria-field__control-area">
      <div
        class="aria-field__input-shell"
        [class.aria-field__input-shell--floating]="useFloatingLabel()"
        [class.aria-field__input-shell--filled]="isFilled()"
        [class.aria-field__input-shell--invalid]="!!errorMessage()"
      >
        <div
          class="aria-combobox"
          ngCombobox
          #comboboxRef="ngCombobox"
          filterMode="manual"
          [readonly]="useMobileDrawer()"
          [disabled]="isDisabled()"
        >
          @if (useMobileDrawer()) {
            <input
              class="aria-field__control aria-field__control--readonly-select"
              [class.aria-field__control--with-suffix]="true"
              ngComboboxInput
              type="text"
              [id]="fieldId"
              [name]="name()"
              [placeholder]="inputPlaceholder()"
              [required]="required()"
              [disabled]="isDisabled()"
              [attr.aria-invalid]="errorMessage() ? 'true' : null"
              [attr.aria-describedby]="describedBy()"
              autocomplete="off"
              readonly
              [value]="triggerLabel()"
              (keydown)="onTriggerKeydown($event)"
            />
          } @else {
            <input
              class="aria-field__control aria-field__control--with-suffix"
              ngComboboxInput
              type="text"
              [id]="fieldId"
              [name]="name()"
              [placeholder]="inputPlaceholder()"
              [required]="required()"
              [disabled]="isDisabled()"
              [attr.aria-invalid]="errorMessage() ? 'true' : null"
              [attr.aria-describedby]="describedBy()"
              autocomplete="off"
              [(value)]="searchValue"
              (valueChange)="onSearchChange($event)"
              (focus)="onTriggerFocus()"
              (keydown)="onTriggerKeydown($event)"
            />
          }

          <ng-template ngComboboxPopupContainer>
            @if (useMobileDrawer()) {
              <dialog
                ngComboboxDialog
                class="aria-combobox__drawer"
                [attr.aria-labelledby]="label() ? drawerTitleId : null"
              >
                @if (label()) {
                  <div class="aria-combobox__drawer-header">
                    <p class="aria-combobox__drawer-title" [id]="drawerTitleId">{{ label() }}</p>
                  </div>
                }
                <input
                  #drawerSearchRef
                  class="aria-combobox__drawer-search"
                  type="search"
                  [placeholder]="placeholder()"
                  [value]="drawerSearchQuery()"
                  [attr.aria-label]="'Cerca ' + (label() || 'opzioni')"
                  (pointerdown)="onDrawerSearchPointerDown($event)"
                  (input)="onDrawerSearchInput($event)"
                  (keydown)="onDrawerSearchKeydown($event)"
                />
                <ul
                  class="aria-listbox aria-listbox--drawer"
                  ngListbox
                  [values]="drawerListboxValues()"
                  selectionMode="explicit"
                >
                  @for (option of filteredOptions(); track option.value) {
                    <li
                      class="aria-listbox__option"
                      ngOption
                      [value]="option.value"
                      [label]="formatDisplayLabel(option.label)"
                      [disabled]="option.disabled ?? false"
                      (click)="onDrawerOptionSelect(option, $event)"
                    >
                      {{ option.label | titlecase }}
                    </li>
                  }
                </ul>
              </dialog>
            } @else {
              <ul
                class="aria-listbox"
                ngListbox
                [values]="selectedValues()"
                (valuesChange)="onValuesChange($event)"
                selectionMode="explicit"
              >
                @for (option of filteredOptions(); track option.value) {
                  <li
                    class="aria-listbox__option"
                    ngOption
                    [value]="option.value"
                    [label]="formatDisplayLabel(option.label)"
                    [disabled]="option.disabled ?? false"
                  >
                    {{ option.label | titlecase }}
                  </li>
                }
              </ul>
            }
          </ng-template>
        </div>

        @if (label() && useFloatingLabel()) {
          <label class="aria-field__floating-label" [attr.for]="fieldId">
            {{ label() }}
            @if (required()) {
              <span class="aria-field__required" aria-hidden="true">*</span>
            }
          </label>
        }

        <span class="aria-field__suffix-icon" [class.aria-field__suffix-icon--custom]="hasSuffix()" aria-hidden="true">
          @if (hasSuffix()) {
            <ng-content select="[ariaFieldSuffix]" />
          } @else {
            <app-icon
              [name]="isPopupExpanded() ? 'CaretUp' : 'CaretDown'"
              [size]="16"
              aria-hidden="true"
            />
          }
        </span>
      </div>
    </div>
  </div>

  @if (hint()) {
    <p class="aria-field__hint" [id]="hintId">{{ hint() }}</p>
  }

  @if (errorMessage()) {
    <p class="aria-field__error" [id]="errorId" role="alert">{{ errorMessage() }}</p>
  }
</div>
